// interfaces & constants
import * as Response from 'src/api/interfaces/responses/profile'
import { PRIVATE_PROFILE_TYPE } from 'src/constants/profile'
import { IProfile } from 'src/interfaces/profile'

// decoders
import { $locationShape } from 'src/api/decoders/location_shape'
import { $profileMarkers } from 'src/api/decoders/marker'
import { $profileTags } from 'src/api/decoders/tags'

export const $profile = (json: Response.IProfile): IProfile => {
  const profile: IProfile = {
    description: json.description,
    gid: json.gid,
    id: json.global_friendly_identifier,
    imageUrl: json.avatar.image_urls.square_small,
    locationShape: json.location_shape ? $locationShape(json.location_shape) : undefined,
    markers: [],
    member_of: json.member_of,
    meta: {
      blacklistsMe: json.meta.blacklists_me,
      fenced: !!json.meta.fenced,
      isBlacklistable: json.meta.is_blacklistable,
      isBlacklisted: json.type === PRIVATE_PROFILE_TYPE
        ? !!json.meta.is_blacklisted
        : false,
      isBookmarkable: json.meta.is_bookmarkable,
      isFollowable: !!json.meta.is_followable,
      isFollowed: !!json.meta.is_followed,
      isFollowing: !!json.meta.is_following,
      isGraylistable: !!json.meta.is_graylistable,
      isGraylisted: !!json.meta.is_graylisted,
      isMessagable: !!json.meta.is_messagable,
      isOwn: !!json.meta.is_own,
      isReadable: !!json.meta.is_readable,
      notifiesMe: !!json.meta.notifies_me
    },
    name: json.name,
    permissions: {
      canBeFollowed: !!json.meta.permissions?.can_be_followed,
      canBlacklist: json.type === PRIVATE_PROFILE_TYPE
        ? !!json.meta.is_blacklistable
        : false,
      canGraylist: !!json.meta.is_graylistable,
      canMessage: !!json.meta.permissions?.can_message,
      canViewDetails: json.type === PRIVATE_PROFILE_TYPE
        ? !!json.meta.is_readable
        : true
    },
    profileLinks: json.profile_links,
    siteNotice: json.site_notice,
    sponsorLevel: json.sponsor_level || undefined,
    tags: json.taggings && $profileTags(json.taggings),
    type: json.type,
    urls: json.urls
      ? {
        blacklist: json.urls.blacklist,
        graylist: json.urls.graylist,
        sendMessage: json.urls.send_message
      }
      : {},
    website: json.website,
    isMessengerEnabled: json.set_messenger_availability === undefined ? true : json.set_messenger_availability
  }

  profile.markers = $profileMarkers(profile, json.markers)

  return profile
}
